import React from "react";

export default function CalendarIcon(props) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13.667" height="15.185">
			<path
				d="M4.556 6.833H3.037v1.519h1.519Zm3.037 0H6.074v1.519h1.519Zm3.037 0H9.111v1.519h1.519Zm1.519-5.315h-.759V0H9.87v1.519H3.8V0H2.278v1.519h-.759A1.512 1.512 0 0 0 .008 3.037L0 13.667a1.518 1.518 0 0 0 1.519 1.518h10.63a1.523 1.523 0 0 0 1.519-1.518V3.037a1.523 1.523 0 0 0-1.52-1.518Zm0 12.148H1.519V5.315h10.63Z"
				fill={`${props.color || "#fff"}`}
			/>
		</svg>
	);
}
